import React, { ReactNode } from 'react';

export const MapButtonContainer = ({ children }: { children: ReactNode }) => {
  return (
    <div className="flex flex-col justify-end p-2 absolute right-0 pointer-events-none z-[15] gap-2 items-end">
      {children}
    </div>
  );
};
